export const cloudAssessmentViewLoader = () => import('./components/cloud-assessment/CloudAssessmentView.js' /* webpackChunkName: "CloudAssessment" */);